import React, { useState } from 'react'
import exifr from 'exifr'
import Footer from './Footer';

const PhotoPage = () =>
{
    // exifr reads the file from disk, only a few hundred bytes.
    // exifr.parse('/graphics/aalborg_techcollege.jpg').then(output => console.log('Camera:', output.Make, output.Model))
    // TODO: Use this logic when 'lightboxing' images
    // NOTE: Luckily, exif metadata can be loaded directly without the need to store it in the database
    // TODO: Check that exif data retrieval also works once uploaded to the web server
    
    // NOTE: When uploading, store photo in the website's filesystem and store the path to the file in the DB.
    const [inputImage, setInputImage] = useState();
    
    const fileChangeEventHandler = (event) => {
        console.log('VALUE: ' + event.target.value);
        setInputImage(event.target.value)
    };
    
    return (
        <div className='w-100' style={{background: '#192047ff'}}>
            <input accept='image/*' type='file' onChange={fileChangeEventHandler} className='p-5 w-25' style={{color: 'white'}}></input>
            <Footer />
        </div>
    )
}

export default PhotoPage